<template>
  <div class="account-user-manage">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="true"
        :paging="paging"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="userStatus" slot-scope="{ param }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="param.row.status == status[1] ? '允许继续创建该角色用户' : '禁止继续创建该角色用户'"
            placement="top"
          >
            <el-switch
              v-model="param.row.status"
              :active-value="status[1]"
              :inactive-value="status[0]"
              @change="changeStatus(param.row)"
            >
            </el-switch>
          </el-tooltip>
        </template>
      </normal-table>
    </common-bg-plate>
    <cert-map ref="certMap"></cert-map>
    <add-user ref="addUser" @update:list="getList()"></add-user>
    <reset-pwd ref="resetPwd"></reset-pwd>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import certMap from './certMap'
import addUser from './addUser'
import resetPwd from './resetPwd'
export default {
  name: 'List',
  components: {
    certMap,
    addUser,
    resetPwd
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新增用户',
          click: () => {
            return this.addUser()
          },
          icon: 'icon-add'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'username',
          label: '用户名',
          minWidth: 228
        },
        {
          prop: 'roleId',
          label: '用户类型',
          formatter: row => {
            return this.judgeRole(row.roleId)
          },
          minWidth: 181
        },
        {
          prop: 'email',
          label: '邮箱',
          minWidth: 225
        },
        {
          prop: 'phone',
          label: '手机',
          minWidth: 219
        },
        {
          prop: 'status',
          label: '状态',
          slotName: 'userStatus',
          minWidth: 172
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '重置密码',
          click: (row, col, cellValue) => {
            return this.resetPwd(row)
          },
          icon: 'icon-reset-password'
        },
        // {
        //   text: '证书映射',
        //   click: (row, col, cellValue) => {
        //     return this.certMapping(row)
        //   },
        //   icon: 'icon-map-certificate'
        // },
        {
          text: '编辑用户',
          click: (row, col, cellValue) => {
            return this.editUser(row)
          },
          icon: 'icon-apply'
        }
        // {
        //   text: '删除用户',
        //   click: (row, col, cellValue) => {
        //     return this.delete(row)
        //   },
        //   icon: 'icon-cancel'
        // }
      ],
      operateCol: {
        minWidth: 174
      },
      //操作弹框
      status: [0, 1],
      options: []
    }
  },
  computed: {
    ...mapState({
      list: state => state.system.user_system_list,
      paging: state => state.system.user_system_paging
    })
  },
  mounted() {
    this.getList()
    this.getRoleOptions()
  },
  methods: {
    ...mapActions(['getUserSystemLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit
      }
      this.getUserSystemLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    getRoleOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.system.getRoleList(param).then(res => {
        if (res.data.items) {
          this.options = res.data.items
        }
      })
    },
    judgeRole(roleId) {
      let item = this.options.filter(ele => ele.Id === roleId)
      return this.$utils.isEmpty(item) ? '—' : item[0]['Name']
    },
    addUser() {
      this.$refs.addUser.handleOpen()
    },
    resetPwd(row) {
      this.$refs.resetPwd.handleOpen(row)
    },
    resetPassword(data) {
      this.$apis.system.resetPwd({ id: data.id }).then(res => {
        if (res) {
          this.$message.success(`用户${data.username}密码重置成功`)
          this.getList()
        }
      })
    },
    certMapping(row) {
      this.$refs.certMap.handleOpen(row)
    },
    editUser(row) {
      this.$refs.addUser.handleOpen(row)
    },
    delete(row) {
      this.$confirm(
        '您正在删除已选中的用户，点击确定执行操作，删除后不可恢复，请谨慎选择，谢谢！',
        '删除用户',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.handleDelete(row)
        })
        .catch(() => {
          console.log('已取消删除')
        })
    },
    handleDelete(data) {
      this.$apis.system.deleteUser({ id: data.id }).then(res => {
        if (res) {
          this.$message.success(`用户${data.username}删除成功`)
          this.getList()
        }
      })
    },
    changeStatus(row) {
      this.$apis.system.reviseUser(row).then(res => {
        if (res) {
          this.$message.success(`${row.username}用户状态更新成功`)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.account-user-manage {
  .normal-table-wrap {
    height: 100%;
    min-height: var(--base-main-router-body-avaliable-height-with-action-bar);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
      }

      .normal-table {
        height: 100%;
        min-height: var(--base-main-router-body-avaliable-height-with-action-bar);
      }
    }
  }
}
</style>
